export default "__VITE_ASSET__q871Dwyv__"